<template>
<div class="chapter">
<div class="inner_page">
<p class="C1166"><span id="page_vii">Contents </span></p>
<p class="C1157"><em><a href="#/html/05_Acknowle#page_ix">Acknowledgments</a></em></p>
<p class="C1164"><em><a href="#/html/06_Introduc#page_1">Introduction: Fat, Gay, Christian</a></em></p>
<p class="C1161"><a href="#/html/07_PART_ONE#page_17"><span class="space"><span class="small">PART ONE</span></span>Framing Right and Wrong</a></p>
<p class="C1162"><a href="#/html/08_1_Sin#page_19"><span class="space">1</span><em>Sin </em></a></p>
<p class="C1163"><span href="#/html/09_2_Health#page_52" title="Link target outside of Sample"><span class="space">2</span><em>Health </em></span></p>
<p class="C1161"><span href="#/html/10_PART_TWO#page_79" title="Link target outside of Sample"><span class="space"><span class="small">PART TWO</span></span>Making Christian Bodies</span></p>
<p class="C1162"><span href="#/html/11_3_Change#page_81" title="Link target outside of Sample"><span class="space">3</span><em>Change, in Theory </em></span></p>
<p class="C1163"><span href="#/html/12_4_Change#page_110" title="Link target outside of Sample"><span class="space">4</span><em>Change, in Practice </em></span></p>
<p class="C1161"><span href="#/html/13_PART_THR#page_153" title="Link target outside of Sample"><span class="space"><span class="small">PART THREE</span></span>Accountings</span></p>
<p class="C1162"><span href="#/html/14_5_Succes#page_155" title="Link target outside of Sample"><span class="space">5</span><em>Success/Failure </em></span></p>
<p class="C1163"><span href="#/html/15_6_Breaki#page_194" title="Link target outside of Sample"><span class="space">6</span><em>Breaking </em></span></p>
<p class="C1132"><em><span href="#/html/16_Conclusi#page_221" title="Link target outside of Sample">Conclusion: Judgment—Religious and Secular</span></em></p>
<p class="C1164"><em><span href="#/html/17_Notes#page_231" title="Link target outside of Sample">Notes</span></em></p>
<p class="C1164"><em><span href="#/html/18_Bibliogr#page_261" title="Link target outside of Sample">Bibliography</span></em></p>
<p class="C1164"><em><span href="#/html/19_Index#page_283" title="Link target outside of Sample">Index</span></em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Contents.vue?44a63468